import * as React from 'react'
import styled from 'styled-components'

import ActionButton from '../../../../components/ui/ActionButton/ActionButton'

const ButtonWrapper = styled.form`
  margin: 1rem 0 0;
`

const BlockActionButton = styled(ActionButton)`
  width: 100%;
`

const BlockButton = styled(ActionButton)`
  width: 100%;
  border-color: transparent;
  font-weight: var(--font-weight-bold);
`

function SkipAddCardForm(props) {
  const { handleSubmit, values } = props

  const { cardCount } = values || {}

  return (
    <ButtonWrapper onSubmit={handleSubmit}>
      {cardCount ? (
        <BlockActionButton variant="primary" type="submit">
          Next
        </BlockActionButton>
      ) : (
        <BlockButton type="submit" data-testid="skipAddCardButton">
          I will add my card later
        </BlockButton>
      )}
    </ButtonWrapper>
  )
}

SkipAddCardForm.defaultProps = {
  // TODO: specify default props
}

SkipAddCardForm.propTypes = {
  // TODO: specify prop types
}

export default SkipAddCardForm
